import * as React from 'react'; 
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { SecurityRoles as roles, BeneficiaryTypes } from '../common/utils';

import paymentActions from '../payment/paymentActions';
import policyActions from '../policy/policyActions';
import userActions from './userActions';

import { Page, PageContent } from '../components/common';
import FirstTimeModal from './FirstTimeModal';
import { Button } from '../components/buttons';
import { IconAdd, IconArrowRight } from '../components/icons';

import Utils from '../common/utils';
import { ensureUserHasRole } from '../auth/authComponents';
import ReferralSection from './ReferralSection';
import authActions from '../auth/authActions';
interface Props {
	currentUser: UserDetails;
	user: UserDetails;
	payments: PaymentHistory[];
	policies: CustomerPolicy[];
	tempPolicyDocumentUrl: string;
	currentBeneficiaries: CustomerPolicyBeneficiaryDto[];
	pendingBeneficiaries: CustomerPolicyBeneficiaryDto[];
	invoice: StripeInvoice;
	actions: any;
	match: any;
}
interface State {
	isFirstTimeModalOpen: boolean;
	isLoading: boolean;
	totalCoverage?: number;
}
class UserHomePage extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isFirstTimeModalOpen: false,
			isLoading: true
		};
	}

	componentDidMount() {
		const userId = this.props.currentUser.id;
		const p1 = this.props.actions.fetchUser(userId);
		const p2 = this.props.actions.fetchCustomerPayments(userId);
		const p3 = this.props.actions.fetchCustomerPolicies(userId).then(() => {
			const totalCoverage = this.props.policies.reduce((total, policy) => total + (policy.coverageAmount || 0), 0);

			this.setState({ totalCoverage });
		});
		const p4 = this.props.actions.fetchCustomerPolicyBeneficiaries(userId);
		const p5 = this.props.actions.fetchCustomerUpcomingInvoice(userId);

		Promise.all([p1, p2, p3, p4, p5])
		.then(() => {
			this.handleFirstTimeLogin();
			return this.setState({ isLoading: false });
		});
	}
	handleFirstTimeLogin = () => {
		if (!this.props.currentUser.hasSignedIn) {
			this.props.actions.setCurrentUserhasSignedIn(true);
			this.setState({ isFirstTimeModalOpen: true });
		}
	}
	onCloseFirstTimeModal = () => {
		this.setState({ isFirstTimeModalOpen: false });
	}

	renderBeneficiaryList = (
		confirmedBeneficiaries: CustomerPolicyBeneficiaryDto[], 
		pendingBeneficiaries: CustomerPolicyBeneficiaryDto[], 
		policyId: string
	) => {
		// currenly only display primary beneficiaries in user dashboard page
		const filteredConfirmed = confirmedBeneficiaries
		.filter(b => b.customerPolicyId === policyId && b.typeId === BeneficiaryTypes.Primary);
		const filteredPending = pendingBeneficiaries
		.filter(b => b.customerPolicyId === policyId && b.typeId === BeneficiaryTypes.Primary);

		return (
			<div>
				{filteredConfirmed && filteredConfirmed.length > 0 ? (
					<div className="p-3 mt-3 ml-4 border">
						<div className="customer-dashboard-plan-info">
							<span className="large">Beneficiaries (Confirmed):</span>
							<Link
								to={`/user/${this.props.user.id}/beneficiaries`}
								className="btn btn-link px-0 arrow-link"
							>
								<span className="arrow-link-content">
									<span className="arrow-link-label">Edit beneficiaries</span>
									<IconArrowRight className="arrow-link-icon" />
								</span>
							</Link>
						</div>
						<ul>
							{filteredConfirmed.map(beneficiary =>
								<li key={beneficiary.id}>{beneficiary.name} ({Utils.toPercent(beneficiary.disbursementPercent)})</li>
							)}
						</ul>
						{(filteredPending && filteredPending.length > 0) && (
							<div className="mt-3">
								<em className="reduced-em">
									You have pending changes. This list will be updated once all beneficiaries have been confirmed.
								</em>
							</div>
						)}
					</div>
				) : (
					<div className="p-3 mt-3 ml-4 border border-warning">
						<div className="customer-dashboard-plan-info">
							<span className="large">Beneficiaries (<strong>Pending</strong>):</span>
							<Link
								to={`/user/${this.props.user.id}/beneficiaries`}
								className="btn btn-link px-0 arrow-link"
							>
								<span className="arrow-link-content">
									<span className="arrow-link-label">Edit beneficiaries</span>
									<IconArrowRight className="arrow-link-icon" />
								</span>
							</Link>
						</div>
						<ul>
							{(filteredPending && filteredPending.length) > 0 ? (
								filteredPending.map(beneficiary =>
									<li key={beneficiary.id}>{beneficiary.name} ({Utils.toPercent(beneficiary.disbursementPercent)})</li>)
								) : (
									<li>
										<em className="reduced-em">No beneficiaries</em>
									</li>
								)
							}
						</ul>
					</div>
				)}
			</div>
		);
	}

	onDownload = (userId: number, policyId: string) => {
		this.props.actions.fetchCustomerPolicyDocumentUrl(userId, policyId).then(() => {
			window.open(this.props.tempPolicyDocumentUrl);
		});
	}

	render() {
		const { policies, currentBeneficiaries, pendingBeneficiaries } = this.props;
		return !this.state.isLoading && (
			<Page title="Dashboard">
				<PageContent sectionClassName="dashboard-row p-0">
					<div className="dashboard-col dashboard-cell customer-dashboard-col-main content-set content-set-lg">
						<header>
							<h1>
								Total coverage: {this.state.totalCoverage ? Utils.formatCurrency(this.state.totalCoverage, 0) : '-'}
							</h1>
						</header>
						<div className="customer-dashboard-plans-wrapper content-set content-set-lg">
							<ul className="list-unstyled mb-0 customer-dashboard-plans">
								{policies.length > 0 ? (
									policies.map(policy => (
										<li key={policy.id} className="customer-dashboard-plan">
											<div className="customer-dashboard-plan-info">
												<strong className="d-inline large">
													Policy {policy.number}: {Utils.formatCurrency(policy.coverageAmount, 0)}
												</strong>
												<span className="d-inline">
													<Button
														onClick={() => this.onDownload(this.props.user.id!, policy.id!)}
														className="btn-link px-0 arrow-link"
													>
														<span className="arrow-link-label">Download policy</span>
														<IconArrowRight className="arrow-link-icon" />
													</Button>
												</span>
											</div>
											{this.renderBeneficiaryList(currentBeneficiaries, pendingBeneficiaries, policy.id!)}
										</li>
									))
								) : (
										<li>
											<em className="reduced-em">No policies</em>
										</li>
									)}
							</ul>
							<p className="workflow-progress-actions text-left">
								<span className="d-block d-md-inline">
									<Button
										to="/quote/A/about-you"
										className="btn-outline-primary btn-icon-wrap workflow-progress-action"
									>
										<span className="align-middle mr-2">Add a policy</span>
										<IconAdd />
									</Button>
								</span>
							</p>
						</div>
					</div>
					<div className="dashboard-col dashboard-col-center customer-dashboard-col">
						<div className="dashboard-row dashboard-cell dashboard-cell-flex justify-content-start">
							{/* take this out for now, since customer can still check their payment info in billing tab
								<p className="large">
									Next payment:&nbsp;
									<strong className="d-inline-block">
										{this.props.invoice.amountDue ? `${Utils.formatCurrency(this.props.invoice.amountDue / 100)}` : '-'}
									</strong>
								</p>
								<p className="mb-0 large">
									Due: <strong className="d-inline-block">{Utils.formatDate(this.props.invoice.date)}</strong>
								</p>
							*/}
							<p className="mt-4">
								<Button
									to={`/user/${this.props.user.id}/billing/view-bills`}
									className="btn-outline-secondary btn-icon-wrap"
								>
									<span className="align-middle mr-2">View your bills</span>
									<IconArrowRight />
								</Button>
							</p>
							<p className="mb-0">
								<Button
									to={`/user/${this.props.user.id}/billing/payment-info`}
									className="btn-outline-secondary btn-icon-wrap"
								>
									<span className="align-middle mr-2">Update your payment info</span>
									<IconArrowRight />
								</Button>
							</p>
						</div>
						<ReferralSection />
					</div>
				</PageContent>
				<FirstTimeModal 
					userId={this.props.user.id} 
					isOpen={this.state.isFirstTimeModalOpen} 
					onRequestClose={this.onCloseFirstTimeModal} 
				/>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return { 
		user: state.user.user,
		payments: state.payment.payments,
		policies: state.policy.policies,
		tempPolicyDocumentUrl: state.policy.tempPolicyDocumentUrl,
		currentBeneficiaries: state.policy.beneficiaries.current,
		pendingBeneficiaries: state.policy.beneficiaries.pending,
		invoice: state.payment.invoice,
		currentUser: state.auth.currentUser
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...paymentActions, ...policyActions, ...userActions, ...authActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedUserHomePage = connect(mapStateToProps, mapDispatchToProps)(UserHomePage);
export default ensureUserHasRole(connectedUserHomePage as any, [roles.Customer]);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/UserHomePage.tsx